// Include jQuery
const $ = require('jquery');

// jQuery Definitionen
window.jQuery = $;
window.$ = $;

require('../vendor/modernizr.touch.js');
require('slick-carousel/slick/slick');
require('slick-carousel/slick/slick.css');

// Helpers
require('../vendor/helper');
require('../vendor/shopHelper');
require('../vendor/jquery-zoombox.min');

// Payment scripts
import '../vendor/payment';

// PayOne scripts
import '../vendor/paymentPayOne';

// Partner search
require('../vendor/__partnerSearch');

require('../vendor/tireFinder');

(function($) {
  /**
   * Ajax-Formulare
   * @param conf
   */
  $.fn.mpAjaxForm = function(conf) {
    const defaults = {};
    const config = $.extend(defaults, conf);
    $(this).find('form:first').submit(function() {
      const form = $(this);
      const ajaxForm = $(form).find('input[name=ajaxform]').val();

      // Formular per Ajax senden?
      if (ajaxForm > 0 && $(form).attr('enctype') !== 'multipart/form-data') {
        $(form).find('input[name=ajaxform]').attr('name', 'ajax_form');
        const form_data = $(this).find('input:not([type=checkbox],[type=checkbox],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select').serialize();

        $.ajax({
          url: form.attr('action'),
          type: form.attr('method'),
          data: form_data,
          success: function(html) {
            $('#c' + ajaxForm).replaceWith(html);
            $('#c' + ajaxForm).mpAjaxForm(conf);

            const formTop = $('#c' + ajaxForm).offset().top;
            if ($(window).scrollTop() > formTop) {
              $('html,body').animate({scrollTop: formTop}, 500);
            }
          },
        });

        return false;
      }
    });
  };
})($);

// Ajax-Formulare (NonTypo-Forms)
(function($) {
  $.fn.ajaxForm = function(conf) {
    const defaults = {};
    const config = $.extend(defaults, conf);
    $(this).on('submit', function() {
      const form = $(this);
      // Formular per Ajax senden?
      if (form.data('action') && $(form).attr('enctype') !== 'multipart/form-data') {
        let formData = $(this).find('input:not([type=checkbox],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select').serialize();
        formData += '&LANG=' + pageLang;

        $.ajax({
          url: form.data('action'),
          type: form.attr('method'),
          data: formData,
          beforeSend: function() {
            $(form).css('position', 'relative').prepend('<div class="form-loader-wrap"><div class="form-loader"><i></i><i></i><i></i><i></i></div></div>');
          },
          success: function(html) {
            $(form).replaceWith(html);
          },
          complete: function() {
            $(form).children('.form-loader-wrap').remove();
          },
        });
        return false;
      }
    });
  };
})(jQuery);

(function($) {
  /**
   * Scripts asynchron laden
   */
  $.extend({
    loadScript: function(source, callback, cache) {
      const c = (typeof cache == 'undefined' ? true : cache);
      (function(d, t) {
        const g = d.createElement(t),
            s = d.getElementsByTagName(t)[0];
        g.src = source + (c === false ? '?_=' + new Date().getTime() : '');
        g.onload = function() {
          callback();
        };
        s.parentNode.insertBefore(g, s);
      }(document, 'script'));
    },
  });
})($);

window.newsletterSubmit = function(form) {

  let sbutton = $('#newsletter-button-submit');
  let sbuttonValue = sbutton.html();
  sbutton.find('button[type=submit]').attr('disabled', 'disabled').html('Bitte warten...');

  const emailAddress = $(form).find('input[type=email]').val();
  $.ajax({
    url: MP_PATH + 'ajax/helper/ajax.newsletterControl.php',
    type: 'post',
    dataType: 'json',
    data: {
      email: emailAddress,
    },
    success: function(response) {
      if (response.success === true) {
        $(form).html(response.message);
      } else {
        $(form).find('.newsletter-error').show().html(response.message);
      }
      sbutton.find('button[type=submit]').removeAttr('disabled').html(sbuttonValue);
    },
  });
};

window.parallaxImg = function() {
  const parallaxImage = $('.parallax-image');
  if (parallaxImage.length) {
    parallaxImage.each(function() {
      const currentParallax = $(this);
      const parallaxPagePosition = currentParallax.offset().top;
      const parallaxHeight = currentParallax.height();
      let scrollPosition = $(window).scrollTop();
      let viewportHeight = $(window).height();

      if (((scrollPosition + viewportHeight) > parallaxPagePosition) && ((scrollPosition) < (parallaxPagePosition + parallaxHeight))) {
        let parallaxImgHeight = currentParallax.children('div').height();

        let newScrollPos = (scrollPosition + viewportHeight) - parallaxPagePosition;
        let fullScrollSpan = (parallaxImgHeight + viewportHeight);

        let newPercentageScrollPos = 100 / fullScrollSpan * newScrollPos;
        let test = parallaxImgHeight * (newPercentageScrollPos / 100);

        currentParallax.children('div').css('transform', 'translateY(' + test + 'px)');
      }
    });
  }
};

// window.autoplayVideo = function () {
//
// }

window.anchorScrolling = function(locHash) {
  setTimeout(function() {
    const hashEleOffsetTop = $(locHash).offset().top;
    let scrollDistanceCorrection = 0;
    const header = $('#header');
    if (header.length) {
      scrollDistanceCorrection = (scrollDistanceCorrection + (header.outerHeight() + 20));
    }
    const scrollTopResult = (hashEleOffsetTop - scrollDistanceCorrection);
    $('html,body').animate({scrollTop: scrollTopResult}, 500);
  }, 100);
};

$(window).on('load', function() {
  if (location.hash !== '' && $(location.hash).length > 0) {
    anchorScrolling(location.hash);
  }
});

$(document).ready(function() {
  // CSS-Klasse wechseln, wenn JS aktiviert ist (für Fallbacks)
  $('html:first').removeClass('no-js').addClass('js');

  // Zoombox starten
  $('.zoombox').zoombox();

  // Bypass-Menu Button
  $('.csc-menu-bypass').click(function(e) {
    e.preventDefault();
    const wrap = $(this).closest('.csc-frame');
    const scrollheight = wrap.offset().top + wrap.height();
    $('html,body').animate({scrollTop: scrollheight}, 500);
  });

  $('.csc-mailform').mpAjaxForm();

  // Alle SVG's als inline SVG - für Farbanpassungen
  jQuery('img.svg').each(function() {
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function(data) {
      // Get the SVG tag, ignore the rest
      var $svg = jQuery(data).find('svg');

      // Add replaced image's ID to the new SVG
      if (typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if (typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass + ' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Replace image with new SVG
      $img.replaceWith($svg);

    }, 'xml');
  });

  $('a[href*="#"]').on('click', function(e) {
    if (this.pathname === window.location.pathname) {
      e.preventDefault();
      // Do something
      const url = $(this).attr('href');
      const hash = url.split('#').pop();
      if ($('#' + hash).length) {
        anchorScrolling('#' + hash);
        window.location.hash = hash;
      }
    }
  });

  // Cursor gleich im Suchfeld
  $('#page-search-header-query').focus();
  // Responsive Menu
  // Menu-Button resettet die Classes vom Menü und lässt das Menü öffnen und schließen
  $('#menu-button').on('click', function() {
    const body = $('body');
    if (body.hasClass('menu-open')) {
      body.removeClass('menu-open');
      $('#menu-overlay').fadeOut(250, function() {
        $(this).remove();
      });
    } else {
      body.addClass('menu-open').append('<div id="menu-overlay"></div>');
      $('#menu-overlay').hide().fadeIn(250).on('click', function() {
        $('#menu-button').trigger('click');
      });
    }
  });
  $('.submenu-open').on('click', function() {
    $(this).closest('li').toggleClass('open');
  });

  // Falls Link in Kacheln (bei Überschrift oder mit Pfeil) dann ganze Kachel verlinken
  const frameLinkKachel = $('.csc-frame-frame-black, .fullscreen-teaser-content');
  if (frameLinkKachel.find('header a, p a').length) {
    frameLinkKachel.find('header a, p a').each(function() {
      const link = $(this);
      const href = link.attr('href');
      const wrap = link.closest('.csc-frame-frame-black, .fullscreen-teaser-content');
      wrap.addClass('hand').on('click', function(e) {
        e.preventDefault();
        window.location.href = href;
      });
    });
  }

  // Foldcontainer
  const foldcontainer = $('.foldcontainer');
  foldcontainer.find($('.fold-body')).hide();
  foldcontainer.find('.fold-header').click(function() {
    $(this).closest(foldcontainer).toggleClass('open').find('.fold-body').stop().slideToggle(150);
  });

  // Heroelment als Slider wenn > 1 hero-item
  if (document.querySelector('.grid-hero')) {
    const gridHero = document.querySelector('.grid-hero');
    const heroItems = gridHero.querySelectorAll('.hero-item');

    if (heroItems.length > 1) {
      gridHero.classList.add('hero-slider');
    }
  }

  // Foldbox
  const gridFoldbox = $('.grid-foldbox');
  gridFoldbox.find('.csc-grid-row').hide();
  gridFoldbox.find('header').click(function() {
    $(this).parent('.grid-foldbox').toggleClass('open').children('.csc-grid-row').stop().slideToggle(250);
    if (gridFoldbox.has('.grid-foldbox')) {
      gridFoldbox.children('.grid-folding-box').find('header').click(function() {
        gridFoldbox.hasClass('.open').has('.grid-foldbox').toggleClass('open').find('.csc-grid-row').stop().slideToggle(250);
      });
    }
  });

  // Different Shipping Address
  $('#differentShippingAddress').on('click', function() {
    if ($(this).is(':checked')) {
      $('#shippingAddress-form').show();
    } else {
      $('#shippingAddress-form').hide();
    }
  });

  // Creditcard Toogle
  $('input[name="pay[paymentType]"]').on('change', function() {
    const paymentCC = $('.paymentCC');
    if ($(this).val() === 3) {
      if (paymentCC.hasClass('active')) {
        paymentCC.removeClass('active');
      } else {
        paymentCC.addClass('active');
      }
    } else {
      paymentCC.removeClass('active');
    }
  });
  // Input Range Bars
  document.querySelectorAll('.range.bar input[type=range]').forEach(function(el) {
    el.oninput = function() {
      var valPercent = (el.valueAsNumber - parseInt(el.min)) /
          (parseInt(el.max) - parseInt(el.min));
      el.style = 'background-image: -webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(' + valPercent + ', #000), color-stop(' + valPercent + ', #E5E5E5));';
    };
    el.oninput();
  });

  parallaxImg();
});

$(window).on('scroll', function() {
  // Change Header on Scroll
  var scroll = $(window).scrollTop();
  if (scroll >= 1) {
    $('#header').addClass('change');
  } else {
    $('#header').removeClass('change');
  }

  // Parallax Pic
  parallaxImg();

  // Fadein
  $('.csc-fadein').each(function() {
    var top_of_element = $(this).offset().top;
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > (top_of_element + 100)) && (top_of_screen < bottom_of_element) && !$(this).hasClass('is-visible')) {
      $(this).addClass('is-visible');
    }
  });

  // Autoplay on local Video only when visible
  $('video[data-autoplay]').each(function() {
    let video = $(this);
    let top_of_element = video.offset().top;
    let bottom_of_element = video.offset().top + video.outerHeight();
    let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    let top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
      // the element is visible, do something
      $(this)[0].play();
    } else {
      // the element is not visible, do something else
      $(this)[0].pause();
    }
  });

  // Autoplay on Youtube Video only when visible
  $('iframe[data-src*="autoplay"]').each(function() {
    let video = $(this);
    //let videoSRC = video.attr('data-src');
    let top_of_element = video.offset().top;
    let bottom_of_element = video.offset().top + video.outerHeight();
    let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    let top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
      // the element is visible, do something
    } else {
      // the element is not visible, do something else
    }
  });
});

$(window).on('load', () => {
  $('.grid-hero.hero-slider').slick({
    fade: false,
    autoplay: true,
    autoplaySpeed: 2200,
    speed: 1200,
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  // Seitenmenü Slider
  const MenuSlider = $('.csc-menu-pages-with-img');
  $('.csc-layout-3 .csc-body .csc-menu-pages-with-img').addClass('full-width');
  if (MenuSlider.length) {
    MenuSlider.slick({
      mobileFirst: true,
      autoplay: true,
      autoplaySpeed: 1800,
      dots: false,
      arrows: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            speed: 800,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
  }

  // Seitemenü Slider wenn volle Breite
  const sliderFullWidth = $('.csc-menu-pages-with-img.full-width');
  sliderFullWidth.slick('unslick');
  sliderFullWidth.slick({
    mobileFirst: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 1800,
    arrows: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          speed: 800,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          centerMode: true,
          centerPadding: '120px',
          slidesToShow: 3,
        },
      },
    ],
  });

  // Slick Slider Config: Content-Slider Standard nur ein Element
  $('.grid-content-slider .csc-grid-col').slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 2800,
    arrows: false,
    dots: true,
    infinite: true,
    swipeToSlide: true,
    slidesToShow: 1,
  });

  // Bilderslider
  $('.pic-slider').slick({
    mobileFirst: true,
    autoplay: true,
    autoplaySpeed: 2200,
    arrows: true,
    dots: false,
    infinite: true,
    swipeToSlide: true,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  // Product Pic Slider
  $('.product-pic.slider').slick({
    infinite: false,
    dots: false,
    slidesToShow: 1,
  });
});

const manageToTopButton = () => {
  let topButton = document.createElement('div');
  topButton.setAttribute('id', 'scroll-top');
  topButton.setAttribute('title', 'Nach oben');
  document.querySelector('body').insertAdjacentElement('beforeend', topButton);

  topButton.addEventListener('click', ev => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  });
};

document.addEventListener('DOMContentLoaded', ev => {
  manageToTopButton();
});